<link rel="stylesheet" href="button-globot-steps.component.scss" />
<div *ngIf="visibleBack && !isMobile" style="position: absolute; bottom: 2vh; left: 10px">
  <globot-button
    [text]="textBack"
    styleClass="secondary"
    icon="pi pi-arrow-left"
    iconPosition="left"
    width="w-100"
    (clickEvent)="onClickBackEvent($event)"
  ></globot-button>
</div>

<div
  *ngIf="visibleCenter && !isMobile"
  style="position: absolute; bottom: 2vh; left: 45%; width: 150px"
>
  <globot-button
    [text]="textBack"
    styleClass="secondary"
    icon="pi pi-arrow-left"
    iconPosition="left"
    width="w-100"
    (clickEvent)="onClickBackEvent($event)"
  ></globot-button>
</div>

<div
  *ngIf="visibleNext && !isMobile"
  style="position: absolute; bottom: 2vh; right: 10px; text-align: right"
>
  <globot-button
    [text]="textNext"
    styleClass="raised"
    icon="pi pi-arrow-right"
    iconPosition="right"
    width="w-100"
    (clickEvent)="onClickNextEvent($event)"
  >
  </globot-button>
</div>

<!--Mobile buttons two buttons-->
<ng-container *ngIf="visibleNext && visibleBack && isMobile; else oneButton">
  <div class="container">
    <div class="layout-button-left">
      <globot-button
        [text]="textBack"
        styleClass="secondary"
        width="w-100"
        icon="pi pi-arrow-left"
        (clickEvent)="onClickBackEvent($event)"
      >
      </globot-button>
    </div>
    <div class="layout-button-right">
      <globot-button
        [text]="textNext"
        styleClass="raised"
        width="w-100"
        iconPosition="right"
        icon="pi pi-arrow-right"
        (clickEvent)="onClickNextEvent($event)"
      >
      </globot-button>
    </div>
  </div>
</ng-container>

<!--Mobile buttons one button-->
<ng-template #oneButton>
  <ng-container *ngIf="isMobile && visibleBack">
    <div style="position: relative; width: 85vw">
      <globot-button
        [text]="textBack"
        styleClass="secondary"
        width="w-100"
        icon="pi pi-arrow-left"
        (clickEvent)="onClickBackEvent($event)"
      >
      </globot-button>
    </div>
  </ng-container>
  <ng-container *ngIf="isMobile && visibleNext">
    <div style="position: relative; bottom: 10px; width: 85vw">
      <globot-button
        [text]="textNext"
        styleClass="raised"
        width="w-100"
        iconPosition="right"
        icon="pi pi-arrow-right"
        (clickEvent)="onClickNextEvent($event)"
      >
      </globot-button>
    </div>
  </ng-container>
  <ng-container *ngIf="isMobile && visibleCenter">
    <div style="position: relative; width: 85vw">
      <globot-button
        [text]="textBack"
        styleClass="secondary"
        width="w-100"
        icon="pi pi-arrow-left"
        (clickEvent)="onClickBackEvent($event)"
      >
      </globot-button>
    </div>
  </ng-container>
</ng-template>
